import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, httpOk } from 'helpers/api'

// Ishlab chiqarish rahbari uchun bo'lim nazorati.
// Faqat o'z bo'limlari (users_product_types) — backend cheklaydi.
// Har bo'lim: faol buyurtma, kechikkan, pipeline hajmi, bosqich taqsimoti.
function Dashboard() {
	const { t } = useTranslation()
	const [departments, setDepartments] = useState([])
	const [loading, setLoading] = useState(true)

	async function load() {
		const res = await GET('/workshop-dashboard', {}, { loader: true })
		if (httpOk(res)) setDepartments(res.data.departments || [])
		setLoading(false)
	}

	useEffect(() => { load() }, [])

	return (
		<>
			<div className="page-header d-flex justify-content-between align-items-center">
				<h4 className="mb-0">{t('department_oversight')}</h4>
			</div>

			{!loading && departments.length === 0 &&
				<div className="card">
					<div className="card-body text-center text-muted py-5">
						<i className="uil-info-circle me-1"></i>{t('no_departments_assigned')}
					</div>
				</div>
			}

			<div className="row g-3">
				{departments.map((d) => (
					<div className="col-lg-4 col-md-6" key={d.product_type}>
						<div className="card h-100">
							<div className="card-body">
								<div className="d-flex justify-content-between align-items-center mb-3">
									<h6 className="fw-bold mb-0">{d.name}</h6>
									{d.late > 0 &&
										<span className="badge bg-danger">
											<i className="uil-clock me-1"></i>{d.late} {t('late_orders')}
										</span>
									}
								</div>

								<div className="row text-center mb-3">
									<div className="col-6 border-end">
										<div className="fs-3 fw-bold" style={{ color: '#1a73e8' }}>{d.active_orders}</div>
										<div className="small text-muted">{t('active_orders')}</div>
									</div>
									<div className="col-6">
										<div className="fs-3 fw-bold" style={{ color: '#0f9d58' }}>{d.volume}</div>
										<div className="small text-muted">{t('volume')}</div>
									</div>
								</div>

								<div className="small text-muted mb-2">{t('production_stages')}</div>
								{d.stages.length === 0
									? <div className="text-muted small">—</div>
									: <div className="d-flex flex-wrap gap-1">
										{d.stages.map((s, i) => (
											<span key={i}
												className="d-inline-flex align-items-center gap-1 border rounded px-2 py-1"
												style={{ fontSize: '12px' }}>
												<span style={{ width: 9, height: 9, borderRadius: '50%', background: s.color, flexShrink: 0 }}></span>
												{s.name} <b>{s.count}</b>
											</span>
										))}
									</div>
								}
							</div>
						</div>
					</div>
				))}
			</div>
		</>
	)
}

export default Dashboard
